import PagesType from '../../types/PagesType';

export const checkPortableMode = (page: PagesType, state: boolean) => {
  return state && page === 'StatPage';
};
